import { AUTO_IMAGE_CROP_APPAREL_TAG_PREFIX, AUTO_IMAGE_CROP_SQUARE_TAG_PREFIX } from "@faire/web--source/common/images/cropUtils/autoImageCropTagPrefix";
import { MANUAL_IMAGE_CROP_APPAREL_TAG_PREFIX, MANUAL_IMAGE_CROP_TAG_PREFIX } from "./manualImageCropTagPrefix";
/**
 * Returns an array of image tags with any crop tags removed.
 * This is used to reset/remove the image crop from an image.
 */ export var removeImageCropTag = function() {
    var tags = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], removedTags = arguments.length > 1 ? arguments[1] : void 0;
    if (removedTags && removedTags.length > 0) {
        return tags.filter(function(tag) {
            return !(removedTags === null || removedTags === void 0 ? void 0 : removedTags.find(function(removedTag) {
                return tag.startsWith(removedTag);
            }));
        });
    }
    return tags.filter(function(tag) {
        return !tag.startsWith(MANUAL_IMAGE_CROP_TAG_PREFIX) && !tag.startsWith(AUTO_IMAGE_CROP_APPAREL_TAG_PREFIX) && !tag.startsWith(AUTO_IMAGE_CROP_SQUARE_TAG_PREFIX) && !tag.startsWith(MANUAL_IMAGE_CROP_APPAREL_TAG_PREFIX);
    });
};
